import { PropsWithChildren, useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { Operations } from 'common/types/TypeDefs';

import { ProfileBar } from './components/ProfileBar';
import { InlineStyles, UserProfileEntityContainerWithAccordeonProps,UserProfileTableHeaderInlineStyles } from './UserProfileEntityContainerTypeDefs';

const PROFILEBAR_COMMON_INLINE_STYLES: InlineStyles = {
    paddingTop: '5px',
    paddingLeft: '16px',
    paddingBottom: '5px'
};

const PROFILEBAR_CREATE_BUTTON_INLINE_STYLES: InlineStyles = {
    paddingTop: '5px',
    paddingLeft: '20px',
    paddingBottom: '5px'
};

export function UserProfileEntityContainerWithAccordeon({
    title,
    isCreateButtonDisabled,
    shouldShowCreateButton,
    operationName = Operations.Link,
    containerInlineStyles,
    createButtonHandler,
    children,
}: PropsWithChildren<UserProfileEntityContainerWithAccordeonProps>) {
    const [expanded, setExpanded] = useState<boolean>(true);
    const handleExpanded = (currentExpanded: boolean) => () => setExpanded(currentExpanded);

    const _buildProfileBarHeaderInlineStyles = (
        operation: Operations
    ): UserProfileTableHeaderInlineStyles => {
        switch(operation) {
            case Operations.Create:
                return {
                    titleInlineStyles: PROFILEBAR_COMMON_INLINE_STYLES,
                    createButtonInlineStyles: PROFILEBAR_CREATE_BUTTON_INLINE_STYLES
                } as UserProfileTableHeaderInlineStyles;
            case Operations.Link:
            default:
                return {
                    titleInlineStyles: PROFILEBAR_COMMON_INLINE_STYLES,
                    createButtonInlineStyles: PROFILEBAR_COMMON_INLINE_STYLES
                } as UserProfileTableHeaderInlineStyles;
        }
    };

    return (
        <Accordion
            expanded={expanded}
            onChange={handleExpanded(!expanded)}
            sx={containerInlineStyles}
            slotProps={{ transition: { unmountOnExit: true } }}
        >
            <AccordionSummary
                expandIcon={expanded ? <RemoveIcon id='expanded' /> : <AddIcon />}
                sx={{
                    height: '4rem',
                    paddingRight: '0px'
                }}
            >
                <ProfileBar
                    title={title}
                    createButtonName={`+ ${operationName}`}
                    shouldShowCreateButton={shouldShowCreateButton}
                    isCreateButtonDisabled={isCreateButtonDisabled}
                    createButtonOnClick={createButtonHandler}
                    testId={`${operationName}(${title})`}
                    profileBarHeaderInlineStyles={_buildProfileBarHeaderInlineStyles(operationName)}
                />
            </AccordionSummary>
            <AccordionDetails
                sx={{
                    width: '100%',
                    padding: 0
                }}
            >
                {children}
            </AccordionDetails>
        </Accordion>
    );
}
